export const CV = {
  hero: {
    firstName: "Oriol",
    secondName: "Molins Casanovas",
    adress: "Calle Mayor 24",
    city: "25100 - Almacelles (Lleida - SPAIN)",
    email: "omolinsc@gmail.com",
    birthDate: "26/04/1985",
    phone: "(+34) 649 653 597",
    image: "/assets/images/profile.jpeg",
    gitHub: "https://github.com/omolinsc",
    linkedIn: "https://www.linkedin.com/in/oriolmolinscasanovas/",
    jobObjective: "Full Stack Developer ( FrontEnd / BackEnd )",
    aboutMe: [
      {
        info: "Enthusiastic about new technologies, programming and videogames.",
      },
      {
        info: "Amateur Padel player, playing almost daily and practicing sports frequently.",
      },
      {
        info: "Fond of drawing, mounting/painting modelism and reading.",
      },
      {
        info: "Animal lover: owner of 2 awsome cats.",
      },
      {
        info: "I am a curious and easy-going person that loves helping my allegates.",
      },
    ],
  },
  education: [
    {
      name: "University Degree in Computer Systems",
      start: "2004",
      date: "...",
      where: "University of Lleida  (Lleida - SPAIN)",
    },
    {
      name: "Certificate of Higher Education in  Administration and Finance",
      start: "2012",
      date: "2014",
      where: "Episcopal School (Lleida - SPAIN)",
    },
    {
      name: "Full Stack Developer",
      start: "2022",
      date: "2023",
      where: "Upgrade Hub (Madrid - SPAIN)",
    },
  ],
  experience: [
    {
      name: "ADMINISTRATIVE ASSISTANT",
      date: "07/2014 – 04/2016",
      where: "Comunitària Administració i Serveis, S.L.",
      description:
        "Management of receipts/invoices via CRM, data entry in the IT environment, elaboration of accounting and balance sheet of expenses/income of the clients (communities of neighbors).",
    },
    {
      name: "WAREHOUSE AND LOGISTICS MANAGER",
      date: "04/2016 – 02/2018",
      where: "CUPASA",
      description:
        "Management of incoming/outgoing goods (phytosanitary products and cereal seeds), management of delivery notes and logistic organization of deliveries and receptions of products.",
    },
    {
      name: "TECHNICAL SALESMAN",
      date: "02/2018 – 02/2020",
      where: "Prefabricados OJEFER, S.L.",
      description:
        "Preparation of estimates and drawings via DraftSight, presentation of the documentation to clients and cold door solicitation in the regions, especially in Catalonia and Aragon (Spain).",
    },
    {
      name: "WAREHOUSE MANAGER AND DELIVERY MAN",
      date: "02/2020 – 11/2022",
      where: "BIOMAURI, S.L.",
      description:
        "Organization and distribution of the company's warehouse materials, which are related to animal feed and vaccination of farms (pigs and cattle).",
    },
    {
      name: "FRONT-END DEVELOPER",
      date: "04/2023 – 02/2026",
      where: "CLEVERPY Machine Learning, S.L.",
      description:
        "Development of products for water treatment and related management, such as pipe revision, flow control, sensor management, etc. All this working with a team of 20 people, remotely, with AGILE metodology. Experience working as a specialist in another project in which I develop tasks such as version upload to QA and Release with Git/BitBucket and provide technical support in the review of tasks and analysis of gaps and improvements of the application, as well as guiding developers to have a better code and best practices.",
    },
    {
      name: "FULL-STACK DEVELOPER",
      date: "02/2026 – ... ",
      where: "ORIGEN STUDIO (InGROUP)",
      description:
        "Product development for various furniture franchises using Shopify (Liquid/JavaScript for the Front-End and Next.js/GraphQL for the Back-End), utilizing the Shopify Partners platform to define data structures and visual themes. Catalog creation for third-party consumption using Medusa with TypeScript, deployed on Railway and managed via Git. Proficient use of AI tools for code generation, including GitHub Copilot and Claude Code, to optimize development workflows and maintain clean code standards.",
    },
  ],
  languages: [
    {
      language: "English",
      wrlevel: "12",
      splevel: "12",
      isNative: false,
    },
    {
      language: "Spanish",
      wrlevel: "15",
      splevel: "15",
      isNative: true,
    },
    {
      language: "Catalan",
      wrlevel: "15",
      splevel: "15",
      isNative: true,
    },
  ],
  otherLanguages: [
    {
      language: "HTML",
      level: "15",
      icon: "/assets/icons/html.png",
    },
    {
      language: "SCSS BEMIT",
      level: "15",
      icon: "/assets/icons/sass.png",
    },
    {
      language: "JavaScript",
      level: "15",
      icon: "/assets/icons/js.png",
    },
    {
      language: "Typescript",
      level: "15",
      icon: "/assets/icons/ts.png",
    },
    {
      language: "C/C++",
      level: "7",
      icon: "/assets/icons/c.png",
    },
    {
      language: "REACT",
      level: "15",
      icon: "/assets/icons/react.png",
    },
    {
      language: "React Native",
      level: "10",
      icon: "/assets/icons/react_native.png",
    },
    {
      language: "Vite",
      level: "13",
      icon: "/assets/icons/vite.svg",
    },
    {
      language: "ReduxTK & RTKQuery",
      level: "13",
      icon: "/assets/icons/rtkquery.png",
    },
    {
      language: "php",
      level: "7",
      icon: "/assets/icons/php.png",
    },
    {
      language: "SQL",
      level: "10",
      icon: "/assets/icons/sql.png",
    },
    {
      language: "Node",
      level: "12",
      icon: "/assets/icons/node.png",
    },
    {
      language: "Angular",
      level: "12",
      icon: "/assets/icons/angular.png",
    },
    {
      language: "Kotlin",
      level: "10",
      icon: "/assets/icons/kotlin.png",
    },
    {
      language: "Android Studio",
      level: "10",
      icon: "/assets/icons/android_studio.png",
    },
    {
      language: "Liquid",
      level: "12",
      icon: "/assets/icons/liquid.png",
    },
    {
      language: "Next.js",
      level: "12",
      icon: "/assets/icons/nextjs.png",
    },
    {
      language: "GrapQL",
      level: "10",
      icon: "/assets/icons/graphql.png",
    },
    {
      language: "PostgreSQL",
      level: "10",
      icon: "/assets/icons/postgresql.png",
    },
    {
      language: "Jest",
      level: "10",
      icon: "/assets/icons/jest.png",
    },
    {
      language: "Vitest",
      level: "10",
      icon: "/assets/icons/vitest.png",
    },
  ],
  tools: [
    {
      tool: "GitHub",
      level: "13",
      icon: "/assets/icons/github.png",
    },
    {
      tool: "GitLab",
      level: "13",
      icon: "/assets/icons/gitlab.png",
    },
    {
      tool: "BitBucket",
      level: "15",
      icon: "/assets/icons/bitbucket.png",
    },
    {
      tool: "Jira",
      level: "15",
      icon: "/assets/icons/jira.png",
    },
    {
      tool: "Jenkins",
      level: "13",
      icon: "/assets/icons/jenkins.png",
    },
    {
      tool: "Figma",
      level: "13",
      icon: "/assets/icons/figma.png",
    },
    {
      tool: "Swagger",
      level: "13",
      icon: "/assets/icons/swagger.png",
    },
    {
      tool: "Windows",
      level: "12",
      icon: "/assets/icons/windows.png",
    },
    {
      tool: "Office",
      level: "15",
      icon: "/assets/icons/office.png",
    },
    {
      tool: "MongoDB",
      level: "12",
      icon: "/assets/icons/mongodb.png",
    },
    {
      tool: "Visual Studio Code",
      level: "15",
      icon: "/assets/icons/vsc.png",
    },
    {
      tool: "Postman",
      level: "12",
      icon: "/assets/icons/postman.png",
    },
    {
      tool: "DraftSight",
      level: "10",
      icon: "/assets/icons/draftsight.png",
    },
    {
      tool: "Photoshop",
      level: "9",
      icon: "/assets/icons/photoshop.png",
    },
    {
      tool: "Illustrator",
      level: "8",
      icon: "/assets/icons/illustrator.png",
    },
    {
      tool: "Shopify Partners",
      level: "12",
      icon: "/assets/icons/shopify_partners.png",
    },
    {
      tool: "Google Cloud Platform",
      level: "10",
      icon: "/assets/icons/google_cloud.png",
    },
    {
      tool: "Asana",
      level: "12",
      icon: "/assets/icons/asana.png",
    },
  ],
  habilities: [
    "Agile & Scrum methodologies",
    "Clean Code",
    "Car license",
    "Pair Programming",
    "Graphic Design",
    "Empathy",
    "Social Media",
    "Creativity",
    "Patience",
    "Efectivity",
    "New technologies",
    "Sports",
  ],
};
